import { useState, useCallback } from 'react';
import { useToast } from '../contexts';

export function useImageCropping() {
  const { showToast } = useToast();
  const [showCropDialog, setShowCropDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [actualImage, setActualImage] = useState(null);
  const [aspect, setAspect] = useState(1);

  const openCropDialog = useCallback((targetImage, uploadedImage) => {
    const h = targetImage.naturalHeight || targetImage.height;
    const w = targetImage.naturalWidth || targetImage.width;
    setAspect(w / h);
    setActualImage(targetImage);
    setSelectedImage(uploadedImage);
    setShowCropDialog(true);
  }, []);

  const closeCropDialog = useCallback(() => {
    setShowCropDialog(false);
    setSelectedImage(null);
    setActualImage(null);
  }, []);

  const handleImageUpload = useCallback((targetImage) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';

    input.addEventListener('change', (e) => {
      const file = e.target.files[0];
      if (!file) return;

      if (file.size > 500 * 1024) {
        showToast('Image size exceeds 500KB. Please select a smaller image.', 'warning');
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          openCropDialog(targetImage, img);
        };
      };
      reader.readAsDataURL(file);
    });

    input.click();
  }, [openCropDialog, showToast]);

  return {
    // State
    showCropDialog,
    selectedImage,
    actualImage,
    aspect,

    // Actions
    openCropDialog,
    closeCropDialog,
    handleImageUpload,
    setShowCropDialog
  };
}
